// import React, { useState, useEffect } from "react";
// import "./DisplayRecipes.css"; // Import your CSS file for styling
// import RecipeDetails from "./RecipeDetails"; // Import the RecipeDetails component
// import EditRecipe from "./EditRecipe";
// // import EditRecipe from "./EditRecipe"; // Import the EditRecipe component

// const DisplayRecipes = () => {
//   const [recipes, setRecipes] = useState([]);
//   const [page, setPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [selectedRecipe, setSelectedRecipe] = useState(null);
//   const [isEditing, setIsEditing] = useState(false);
//   const [isViewingDetails, setIsViewingDetails] = useState(false);

//   useEffect(() => {
//     fetchRecipes();
//   }, [page]);

//   const fetchRecipes = async () => {
//     try {
//       const response = await fetch(
//         `http://localhost:3030/api/recipe/getall?page=${page}&perPage=10`
//       ); // Adjust perPage as needed
//       const data = await response.json();
//       setRecipes(data.results);
//       setTotalPages(Math.ceil(data.totalResults / 10)); // Assuming 10 recipes per page
//     } catch (error) {
//       console.error("Error fetching recipes:", error);
//     }
//   };

//   const handleEdit = (recipeId) => {
//     const selected = recipes.find((recipe) => recipe.id === recipeId);
//     setSelectedRecipe(selected);
//     setIsEditing(true);
//   };

//   const handleDelete = async (recipeId) => {
//     try {
//       const response = await fetch(`/api/deleterecipe/${recipeId}`, {
//         method: "DELETE",
//       });
//       if (response.ok) {
//         // Remove the deleted recipe from the state
//         setRecipes(recipes.filter((recipe) => recipe.id !== recipeId));
//         console.log("Recipe deleted successfully");
//       } else {
//         console.error("Failed to delete recipe");
//       }
//     } catch (error) {
//       console.error("Error deleting recipe:", error);
//     }
//   };

//   const handleDetails = (recipeId) => {
//     const selected = recipes.find((recipe) => recipe.id === recipeId);
//     setSelectedRecipe(selected);
//     setIsViewingDetails(true);
//   };

//   const handlePageChange = (newPage) => {
//     setPage(newPage);
//   };

//   const handleEditClose = () => {
//     setIsEditing(false);
//     setSelectedRecipe(null);
//   };

//   const handleDetailsClose = () => {
//     setIsViewingDetails(false);
//     setSelectedRecipe(null);
//   };

//   return (
//     <div className="display-recipes-container-admin">
//       <h2>Recipes</h2>
//       <table>
//         <thead>
//           <tr>
//             <th>Title</th>
//             <th>Short Description</th>
//             <th>Author</th>
//             <th>Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {recipes.map((recipe, index) => (
//             <tr key={index}>
//               <td>{recipe.title_name}</td>
//               <td>{recipe.short_description}</td>
//               <td>{recipe.author_name}</td>
//               <td>
//                 <button
//                   onClick={() => handleEdit(recipe.id)}
//                   className="admin-display-recipe-button"
//                 >
//                   Edit
//                 </button>
//                 <button
//                   onClick={() => handleDelete(recipe.id)}
//                   className="admin-display-recipe-button"
//                 >
//                   Delete
//                 </button>
//                 <button
//                   onClick={() => handleDetails(recipe.id)}
//                   className="admin-display-recipe-button"
//                 >
//                   Details
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//       {selectedRecipe && isEditing && (
//         <EditRecipe recipe={selectedRecipe} onClose={handleEditClose} />
//       )}
//       {selectedRecipe && isViewingDetails && (
//         <RecipeDetails recipe={selectedRecipe} onClose={handleDetailsClose} />
//       )}
//       <div className="pagination">
//         <button
//           onClick={() => handlePageChange(page - 1)}
//           disabled={page === 1}
//         >
//           Previous
//         </button>
//         <span>
//           {page} of {totalPages}
//         </span>
//         <button
//           onClick={() => handlePageChange(page + 1)}
//           disabled={page === totalPages}
//         >
//           Next
//         </button>
//       </div>
//     </div>
//   );
// };

// export default DisplayRecipes;

import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";

const DisplayRecipes = () => {
  const [recipes, setRecipes] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const [selectedRecipe, setSelectedRecipe] = useState(null);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    fetchRecipes();
  }, []);

  const fetchRecipes = async () => {
    try {
      const response = await fetch("http://localhost:3090/api/recipe/getall"); // Replace with your backend endpoint
      const data = await response.json();
      setRecipes(data.results);
    } catch (error) {
      console.error("Error fetching recipes:", error);
    }
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenDetailsDialog = (recipe) => {
    setSelectedRecipe(recipe);
    setOpenDetailsDialog(true);
  };

  const handleOpenEditDialog = (recipe) => {
    setSelectedRecipe(recipe);
    setFormData({ ...recipe });
    setOpenEditDialog(true);
  };

  const handleOpenDeleteDialog = (recipe) => {
    setSelectedRecipe(recipe);
    setOpenDeleteDialog(true);
  };

  const handleCloseDialogs = () => {
    setOpenDetailsDialog(false);
    setOpenEditDialog(false);
    setOpenDeleteDialog(false);
    setSelectedRecipe(null);
    setFormData({});
  };

  const handleEditSubmit = async () => {
    try {
      const response = await fetch(`/api/recipes/${selectedRecipe.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error("Failed to update recipe");
      }

      const updatedRecipe = await response.json();
      setRecipes((prev) =>
        prev.map((recipe) =>
          recipe.id === updatedRecipe.id ? updatedRecipe : recipe
        )
      );
      console.log("Recipe updated:", updatedRecipe);
    } catch (error) {
      console.error("Error updating recipe:", error);
    } finally {
      handleCloseDialogs();
    }
  };

  const handleDeleteSubmit = async () => {
    try {
      const response = await fetch(`/api/recipes/${selectedRecipe.id}`, {
        method: "DELETE",
      });

      if (!response.ok) {
        throw new Error("Failed to delete recipe");
      }

      setRecipes((prev) =>
        prev.filter((recipe) => recipe.id !== selectedRecipe.id)
      );
      console.log("Recipe deleted:", selectedRecipe);
    } catch (error) {
      console.error("Error deleting recipe:", error);
    } finally {
      handleCloseDialogs();
    }
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {recipes
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((recipe) => (
                <TableRow key={recipe.title_id}>
                  <TableCell>{recipe.title_id}</TableCell>
                  <TableCell>{recipe.title_name}</TableCell>
                  <TableCell>{recipe.short_description}</TableCell>
                  <TableCell>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={() => handleOpenEditDialog(recipe)}
                      sx={{ marginRight: 1 }}
                    >
                      Edit
                    </Button>
                    <Button
                      variant="contained"
                      color="error"
                      size="small"
                      onClick={() => handleOpenDeleteDialog(recipe)}
                      sx={{ marginRight: 1 }}
                    >
                      Delete
                    </Button>
                    <Button
                      variant="outlined"
                      color="info"
                      size="small"
                      onClick={() => handleOpenDetailsDialog(recipe)}
                    >
                      See Details
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={recipes.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      </TableContainer>

      {/* See Details Dialog */}
      <Dialog open={openDetailsDialog} onClose={handleCloseDialogs}>
        <DialogTitle>Recipe Details</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            <b>ID:</b> {selectedRecipe?.title_id}
          </Typography>
          <Typography variant="body1">
            <b>Name:</b> {selectedRecipe?.title_name}
          </Typography>
          <Typography variant="body1">
            <b>Description:</b> {selectedRecipe?.short_description}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialogs} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Dialog */}
      <Dialog open={openEditDialog} onClose={handleCloseDialogs}>
        <DialogTitle>Edit Recipe</DialogTitle>
        <DialogContent>
          <TextField
            label="Name"
            name="title_name"
            value={formData.title_name || ""}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
          <TextField
            label="Description"
            name="short_description"
            value={formData.short_description || ""}
            onChange={handleInputChange}
            fullWidth
            margin="dense"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialogs} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleEditSubmit} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Dialog */}
      <Dialog open={openDeleteDialog} onClose={handleCloseDialogs}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          Are you sure you want to delete the recipe{" "}
          <b>{selectedRecipe?.title_name}</b>?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialogs} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleDeleteSubmit} color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DisplayRecipes;
